// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_revolved_eyelet_ring/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_revolved_eyelet_ring: ModuleSchema = {
  "id": "core_revolved_eyelet_ring",
  "uniqueId": "B3D_EYE01",
  "createdAt": "2026-10-11T05:00:00Z",
  "updatedAt": "2026-10-11T09:57:51.697Z",
  "label": "Perimeter Eyelet Ring",
  "description": "Standalone core geometry module for rounded eyelet hook ring (CG_EYE01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_EYE01",
    "eyelet-ring",
    "hook"
  ],
  "sliders": [
    {
      "key": "innerRadius",
      "label": "Inner Radius (mm)",
      "min": 0.8,
      "max": 5,
      "default": 1.8,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "outerRadius",
      "label": "Outer Radius (mm)",
      "min": 1.5,
      "max": 8,
      "default": 3.2,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "depth",
      "label": "Torus Depth (mm)",
      "min": 0.8,
      "max": 6,
      "default": 1.6,
      "step": 0.2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "edgeRound",
      "label": "Edge Fillet (mm)",
      "min": 0.1,
      "max": 1.5,
      "default": 0.35,
      "step": 0.05,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "ring",
      "label": "Eyelet Ring Color",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "eyelet_ring",
      "name": "Eyelet Ring Solid",
      "parts": [
        {
          "id": "eyelet_part",
          "name": "Revolved Eyelet Ring",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Eyelet Ring"
    }
  ]
};
